import { Image } from "@mantine/core";
import { ClassAttributes, ImgHTMLAttributes } from "react";
import ReactMarkdown, { ExtraProps } from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const ImageReactMarkdown = (
  imageData: ClassAttributes<HTMLImageElement> & ImgHTMLAttributes<HTMLImageElement> & ExtraProps,
) => {
  return <Image src={imageData.src}></Image>;
};

export const InnerMarkdown = ({ children }: { children: string }) => {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw, remarkGfm]}
      components={{
        img: ImageReactMarkdown,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
